import { GenericDrawer } from '@/components'
import Vue from 'vue'
import { VBtn, VCol, VContainer, VIcon, VSkeletonLoader, VCardText, VForm, VRow, VCard, VDivider, VCardSubtitle } from 'vuetify/lib'
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import axios from 'axios'
import { IPreAnaliseDetalhesItemList } from '@/interfaces/IPreAnaliseDetalhesItemList'
import { CreditoImobiliarioService } from '@/services'
import { getHoursByDate } from '@/filters/date'
import './PreAnalysisObservation.scss'
import { AbreviacaoFilter } from '@/filters'

export const ObservationDrawer = Vue.component('ObservationDrawer', {
	props: {
		preAnalysisId: {
			type: Number,
			required: false
		}
	},

	data: () => ({
		currentTab: 0,
		name: 'ObservationDrawer',
		currentValue: '',
		editor: {} as typeof Quill,
		currentValueLenght: 0,
		isLoading: true,
		snackbar: false,
		snackbarText: '',
		observations: new Array<IPreAnaliseDetalhesItemList>(),
		observation: '',
		ERROR_MESSAGE: 'Falha em adicionar a observação.',
		minCharacters: 10,
		resizeHeight: document.body.scrollHeight - 250
	}),

	render() {
		return (
			<GenericDrawer
				onDrawerStateChange={this.onDrawerStateChange}
				title="Observações da Pré-Análise"
				ref="drawerObservation"
				class="lock-obs"
			>
				<VContainer column class="preanalysis-observacao-view">
					<VRow>
						<VCol cols="12" class="preanalysis-box">
							<VCard id="observacao-area" elevation="0" outlined class="d-flex flex-column position-relative" maxHeight={this.resizeHeight}>
								<VSkeletonLoader
									class="flex-grow overflow-y-auto"
									ref="appPreanalysisObservacoes"
									id="app-preanalysis-observacoes"
									loading={this.isLoading}
									type="article"
								>
									<div class="py-5">
										{this.filteredObservacoesDate.map((item) => {
											return (
												<div>
													<div class="preanalysis-data text-center" color="white">
														{item.observation[0].data.split(',')[0]}
													</div>

													<div>{item.observation.map(this.renderObservacao)}</div>
												</div>
											)
										})}
									</div>
								</VSkeletonLoader>
								<VDivider></VDivider>
								<VCol cols="12" class="preanalysis-editor" outlined>
									<VForm ref="form">
										<VCol class="text-editor">
											<div class="text-editor"></div>
										</VCol>
									</VForm>
								</VCol>
							</VCard>
						</VCol>
					</VRow>
				</VContainer>

				<div class="submit-btn-container">
					<VBtn
						onClick={() => this.addObservation()}
						class="d-flex flex-column"
						elevation="0"
						color="primary"
						type="submit"
						disabled={this.isDisabled()}
					>
						<VIcon color="white" size="16">
							mdi-send
						</VIcon>
						Registrar observação
					</VBtn>
				</div>
			</GenericDrawer>
		)
	},

	mounted() {
		this.initEditor()
		this.getObservacoes()

		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize)
		})
	},

	beforeDestroy() {
		window.removeEventListener('resize', this.onResize)
	},

	methods: {
		renderObservacao(item: IPreAnaliseDetalhesItemList) {
			return (
				<VCard elevation="0" class="d-flex flex-column position-relative mb-2 mx-1">
					<VCardSubtitle class="preanalysis-title">
						{AbreviacaoFilter(item.user.name)} - {AbreviacaoFilter(item.user.franchiseName)}
					</VCardSubtitle>
					<VCardText class="m-0 p-0 app-preanalysis-observacao-item">
						<div class="card-observation-text">
							<span>{item.observation}</span>
						</div>
					</VCardText>
					<VCardText class="m-0 p-0">
						<span class="message-date d-flex justify-start">{item.hours}</span>
					</VCardText>
				</VCard>
			)
		},

		onDrawerStateChange(value: boolean) {
			if (!value) {
				this.observations = new Array<IPreAnaliseDetalhesItemList>()
				this.isLoading = true
			}

			this.$emit('onDrawerStateChange', value)
		},

		openDrawer() {
			// Clear list
			this.observations = new Array<IPreAnaliseDetalhesItemList>()
			this.getObservacoes()

			const drawer = this.$refs.drawerObservation as GenericDrawer
			drawer.openDrawer()
		},

		initEditor() {
			//@ts-ignore
			this.editor = new Quill('.text-editor', {
				modules: {
					toolbar: [[{ header: [1, 2, false] }], ['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }]]
				},
				placeholder: 'Descreva a Observação',
				theme: 'snow'
			})

			//@ts-ignore
			this.editor.on('text-change', (delta, oldDelta, source) => {
				//@ts-ignore
				this.currentValue = this.editor.root.innerText.trim()

				//@ts-ignore
				this.currentValueLenght = this.editor.root.innerText.trim().length
			})
		},
		async onVisible(entries: any) {
			if (entries[0].isIntersecting) {
				await this.scrollToEnd()
			}
			this.getObservacoes
		},
		async scrollToEnd() {
			await this.$nextTick()
			const el = document.getElementById('app-preanalysis-observacoes')
			if (el) {
				el.scrollTop = el.scrollHeight
			}
		},
		async getObservacoes() {
			this.isLoading = true

			try {
				const response = await CreditoImobiliarioService.getPreAnalysisObservations(this.currentPreAnalisysId)
				this.observations = response.result as Array<IPreAnaliseDetalhesItemList>

				this.isLoading = false
				await this.scrollToEnd()
			} catch (error) {
				if (axios.isAxiosError(error)) error.response
			}
			this.isLoading = false
		},
		async addObservation() {
			try {
				const response = await CreditoImobiliarioService.addObservation(this.currentPreAnalisysId, this.currentValue, this.currentUser)
				if (response) {
					this.getObservacoes()
				} else console.error(this.ERROR_MESSAGE)
			} catch (error) {
				if (axios.isAxiosError(error)) {
					console.error(this.ERROR_MESSAGE, error.response)
				}
			}
			//@ts-ignore
			this.editor.root.innerText = ''
		},
		isDisabled() {
			return this.currentValueLenght < 10
		},

		onResize() {
			this.resizeHeight = document.body.scrollHeight - 250
		}
	},

	watch: {
		preAnalysisId: {
			handler(val: number) {
				this.observations = new Array<IPreAnaliseDetalhesItemList>()
				if (val) {
					this.getObservacoes()
				}
			}
		}
	},

	computed: {
		currentPreAnalisysId() {
			return this.preAnalysisId || parseInt(this.$route.params.preanaliseId) || 0
		},

		filteredObservacoesDate() {
			let convertDate: Array<IPreAnaliseDetalhesItemList> = this.observacoesFiltered.map((item: IPreAnaliseDetalhesItemList) => ({
				...item,
				hours: getHoursByDate(item.creationDate),
				data: Intl.DateTimeFormat('pt-BR').format(new Date(item.creationDate))
			}))
			let dates = [...new Set(convertDate.map((item: IPreAnaliseDetalhesItemList) => item.creationDate.split('T')[0]))]
			let datesFiltered = dates.map((item) => ({
				data: item,
				observation: convertDate.filter((observation: IPreAnaliseDetalhesItemList) => observation.creationDate.split('T')[0] === item)
			}))
			return datesFiltered
		},

		observacoesFiltered() {
			let observacoesFiltered: Array<IPreAnaliseDetalhesItemList> = this.observations.sort(
				(a: IPreAnaliseDetalhesItemList, b: IPreAnaliseDetalhesItemList) => {
					if (a.id > b.id) return 1
					if (a.id < b.id) return -1
					return 0
				}
			)
			return observacoesFiltered
		},
		currentUser() {
			const { state } = this.$store
			return state.user.id as number
		}
		// resizeHeight() {
		// 	console.log(document.body.scrollHeight)
		// 	return document.body.scrollHeight - 250
		// }
	}
})

export default ObservationDrawer
